import { render } from "./AdminLegacies.vue?vue&type=template&id=5fdf4ba1"
import script from "./adminLegacies.js?vue&type=script&lang=js&external"
export * from "./adminLegacies.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__